/**
 * Checks whether the value is in range of min and max. If lower than min, it returns min, if higher than max, it returns max. Otherwise, it returns the checked value.
 * @param value value to be checked
 * @param min lowest possible value
 * @param max highest possible value
 */
export const clamp = (value: number, min: number, max: number): number => {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
};
